export default "__VITE_ASSET__O1zo_Xvc__"